export default __webpack_public_path__ + "static/media/detail_mobile_12_5.81edac99.jpg";